import initEditButtons from './myAccount/accountDetails';
import initAddressForm from './myAccount/addressForm';
import initPostcodeHandler from './myAccount/addressPostCodeLookup';
import initMyAccount from './myAccount/myAccount';
import initPasswordToggles from '../helpers/passwordToggle';

import '../../../pcss/my-account.pcss';

window.addEventListener('DOMContentLoaded', () => {
  initEditButtons();
  initAddressForm();
  initPostcodeHandler();
  initMyAccount();
  initPasswordToggles();
});
